import React from 'react';
import { Breadcrumb, Avatar, Typography } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const PageLayout = ({ 
  title, 
  desc, 
  avatar, 
  breadcrumb = [], 
  children, 
  extra,
  headerContent 
}) => {
  return (
    <div style={{ margin: '-24px -24px 0px' }}>
      {/* Page Header */}
      <div style={{
        background: '#fff',
        padding: '16px 24px',
        borderBottom: '1px solid #f0f0f0',
        marginBottom: '24px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '16px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {avatar && (
              <Avatar 
                src={avatar} 
                size={64} 
                style={{ marginRight: '16px' }}
              />
            )}
            <div>
              <Title level={2} style={{ margin: 0, marginBottom: '8px' }}>
                {title}
              </Title>
              {desc && (
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {desc}
                </Text>
              )}
            </div>
          </div>
          {extra && (
            <div>
              {extra}
            </div>
          )}
        </div>
        
        {headerContent && (
          <div>
            {headerContent}
          </div>
        )}
        
        {breadcrumb.length > 0 && (
          <Breadcrumb style={{ marginTop: '16px' }}>
            <Breadcrumb.Item>
              <HomeOutlined />
            </Breadcrumb.Item>
            {breadcrumb.map((item, index) => (
              <Breadcrumb.Item key={index}>
                {item.name || item.title}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
      </div>
      
      {/* Page Content */}
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
